import { NwIpV4NetmaskSubnetInput } from '@fafm/neowise-core';
import { neowiseIpInputField } from './FmkIpV4Input';

export const FmkIpV4NetmaskSubnetInput = neowiseIpInputField(
  NwIpV4NetmaskSubnetInput,
  {}
);
FmkIpV4NetmaskSubnetInput.displayName = 'FmkIpV4NetmaskSubnetInput';
